// extracted by mini-css-extract-plugin
module.exports = {"select":"Multiselect_select__33orB"};